import produce from 'immer';
import { combineReducers } from 'redux';
import RcInstanceDTO from '@robocorp/robocloud-internal-cds-sdk/lib/sdk/Types';
import { ProcessAction, ProcessActionType } from '../../actions/processActions';

interface ProcessState {
  byId: Record<string, RcInstanceDTO.Process>;
  allIds: string[];
}

export const initialState: ProcessState = {
  byId: {},
  allIds: [],
};

const byId = (state = initialState.byId, action: ProcessAction) =>
  produce(state, (draft) => {
    switch (action.type) {
      case ProcessActionType.GET_PROCESSES:
        return {};
      case ProcessActionType.GET_PROCESSES_OK: {
        action.data.forEach((proc) => {
          draft[proc.id] = proc;
        });

        break;
      }
      case ProcessActionType.GET_PROCESS_OK: {
        draft[action.data.id] = action.data;
        break;
      }
      case ProcessActionType.CREATE_PROCESS_OK: {
        draft[action.data.id] = action.data;
        break;
      }
      case ProcessActionType.EDIT_PROCESS_OK: {
        draft[action.processId] = action.data;
        break;
      }
      case ProcessActionType.GENERATE_PROCESS_SECRET_OK: {
        draft[action.processId] = action.data;
        break;
      }
      case ProcessActionType.DELETE_PROCESS_OK: {
        delete draft[action.processId];
        break;
      }
      case ProcessActionType.DELETE_PROCESS_SECRET_OK: {
        delete draft[action.processId].secret;
        break;
      }
      default:
        return state;
    }
  });

const allIds = (state = initialState.allIds, action: ProcessAction) => {
  switch (action.type) {
    case ProcessActionType.GET_PROCESSES:
      return [];
    case ProcessActionType.GET_PROCESSES_OK:
      return action.data.map((proc) => proc.id);
    case ProcessActionType.GET_PROCESS_OK:
      return state.includes(action.data.id) ? state : [...state, action.data.id];
    case ProcessActionType.CREATE_PROCESS_OK:
      return [action.data.id, ...state];
    case ProcessActionType.DELETE_PROCESS_OK:
      return state.filter((id) => id !== action.processId);
    default:
      return state;
  }
};

export default combineReducers({ byId, allIds });
